const actions = {
  // NOTE // closeFlight & openFlight
  'closeFlight': {
    userTypes: ['admin', 'reservations', 'scheduling', 'handler'],
    airlines: ['TJ', '4N', 'ZW']
  },
  // NOTE // checkIn & checkout
  'checkIn': {
    userTypes: ['admin', 'reservations', 'scheduling', 'handler', 'pilot'],
    airlines: ['TJ', '4N', 'ZW']
  },
  // NOTE // viewComment & addComment
  'viewComment': {
    userTypes: ['admin', 'reservations', 'scheduling', 'handler', 'pilot'],
    airlines: ['TJ', '4N', 'ZW']
  },
  'editPax': {
    userTypes: ['admin', 'reservations', 'scheduling', 'handler', 'pilot'],
    airlines: ['TJ', '4N', 'ZW']
  },
  'editTime': {
    userTypes: ['admin', 'scheduling'],
    airlines: ['TJ', '4N','ZW']
  },
  'editDCSFlight': {
    userTypes: ['admin'],
    airlines: ['4N','ZW']
  },
  'movePax': {
    userTypes: ['admin', 'reservations', 'scheduling', 'handler'],
    airlines: ['TJ']
  },
  'textPax': {
    userTypes: ['admin', 'reservations', 'scheduling', 'handler', 'pilot'],
    airlines: ['TJ']
  },
  'addNonAdminUser': {
    userTypes: ['admin'],
    airlines: ['TJ','ZW']
  }
}

const hasType = (userType, airline, actionType, show) => {
  if (show) {
    return actionType.airlines.includes(airline) ? 'block' : 'none'
  }
  else {
    return actionType.userTypes.includes(userType.toLowerCase()) && actionType.airlines.includes(airline)
  }
}

// NOTE // Access to specific actions are checked here, while access to pages is checked in mainDisplay. There is additional checking in the back-end for each route using gateKeeper.
// NOTE // setting show as true will check whether the option should display and return 'none' or 'block' (i.e. 4N shouldn't see movePax)
// NOTE // example inputs "admin", "4N", "movePax", true
const checkPermissions = (userType, airline, action, show) => {
  let isAccessible = false
  let actionType = actions[action]
  if (userType && typeof userType === 'string' && airline && typeof airline === 'string' && actionType) {
    isAccessible = hasType(userType, airline, actionType, show)
  }

  return isAccessible
}

export default checkPermissions